import { render } from "./EditSport.vue?vue&type=template&id=254ee544"
import script from "./EditSport.vue?vue&type=script&lang=js"
export * from "./EditSport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__